
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.orderForm, arguments)" @resolve="submitHandle">
		<c-form ref="orderForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="退货单号">
					<c-input name="return_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="仓库" required>
					<c-select ref="warehouse" name="warehouse_id" v-model="warehouse_id" async @search="searchWarehouse"  :value-data="warehouseOptions" :clear="false"></c-select>
					<template #handle>
						<c-tooltip tip="退货核准后，相关商品将自动入库到当前仓库" position="top"></c-tooltip>
					</template>
				</c-form-item>
                <c-form-item label="客户名称">
                    <c-select name="customer_id" async v-model="customer_id" @search="searchCustomer" :value-data="customerOptions" @change="changeCustomer"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_customer_edit')" @click="globalDialog('customerEdit',{})">创建客户</c-link>
                    </template>
                </c-form-item>
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="53"></custom-form>
			</c-form>

			<c-title>退货明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="returnProductTable" view-id="10021" work-type="54">
					<template #operate>
                        <c-button prepend-icon="tf-add" @click="addReturnOrder()">添加订单</c-button>
                        <c-button prepend-icon="tf-add" @click="addReturnProduct()">添加产品</c-button>
						<c-button prepend-icon="tf-reload" :disabled="!customer_id" @click="loadCustomerOrder()">按客户重新加载可退货明细</c-button>
					</template>

					<template #otherOperate>
						<c-button color="red" hollow prepend-icon="tf-clear" @click="clearNonData()">清除无效数据</c-button>
					</template>

					<!--订单|产品-->
					<template #order_number="{data, update}">
                        <c-select v-if="data.type == 1"
							v-model="data.order_product_id"
							name="order_product_id"
							async
							:value-data="data.orderOptions"
							@search="searchOrderProduct"
							@change="changeOrderProduct($event, update)"
                        >
							<template #option="{data, selected}">
								<select-option
									:name="data.name"
									:info="[
										textJoin(data.data.product_code, data.data.product_name, data.data.product_spec)
									]"
									:selected="selected"
								></select-option>
							</template>
                        </c-select>
                        <span v-else>{{data.order_number || '-'}}</span>
                    </template>

					<!--产品编号-->
					<template #product_code="{data, update}">
						<c-select v-if="data.type == 2"
							v-model="data.product_id"
							name="product_id"
							async
							:value-data="data.productCodeOptions"
							@search="searchProduct"
							@change="changeProduct($event, update)"
						>
							<template #option="{data, selected}">
								<select-option
									:name="data.data.product_code"
									:info="[
										textJoin(data.data.product_name, data.data.product_spec)
									]"
									:selected="selected"
								></select-option>
							</template>
						</c-select>
						<span v-else>{{data.product_code || '-'}}</span>
                    </template>

                    <!--下单数-->
                    <template #main_product_count="{data}">
                        <span v-if="data.main_product_count">{{data.main_product_count}}{{data.unit}}</span>
                        <span v-else>-</span>
                    </template>

					<!--已发货数-->
					<template #deliver_count="{data}">
					    <span v-if="data.type==1">{{data.deliver_count}}{{data.unit}}</span>
					    <span v-else>-</span>
					</template>

					<!--产品数量-->
					<template #return_count="{data}">
						<c-input v-if="data.type && data.type>0" v-model="data.return_count" name="return_count" type="number" decimal="6" :range="[0,99999999]" :clear="false" :append-text="data.unit"></c-input>
						<span v-else>{{data.return_count}}{{data.unit}}</span>
					</template>

                    <!--操作栏-->
                    <c-table-column
                        type="button"
                        label="操作"
						width="60"
                    >
                        <template #default="{data,remove}">
                            <c-table-button v-if="data.type && data.type>0"  icon="tf-trash" color="red" @click="removeProductRow(data,remove)">删除</c-table-button>
                        </template>

                    </c-table-column>

				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'orderReturnEdit',

		data() {
			return {
				customer_id: '',
				warehouse_id: 0,
				warehouseOptions: [],
                customerOptions: [],
				return_id: 0
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig'])
		},

		methods: {
			open(data = {}) {
				this.return_id = 0;
				let {orderId, returnId, productList} = data;
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化退货商品表格控件
				this.$refs.returnProductTable.init();
				//清空表单数据
				this.$refs.orderForm.clear();
				this.getDefaultWarehouse();
				let title = "创建退货单";
				if (orderId) {
					//查询订单详情
					this.request({
						url: '/order/detail',
						data: {
							id: orderId
						},
						loading: true,
						success: data => {
							//处理选中客户信息
							if (data.detailInfo.customer_id) {
								this.customer_id = data.detailInfo.customer_id;
								this.customerOptions = [{
									name: data.detailInfo.customer_code + ' | ' + data.detailInfo.customer_name,
									value: data.detailInfo.customer_id
								}];
							}

							//加载订单产品列表
							let ids = [];
							let product_list  = Array.from(productList || data.productList, item => {
								ids.push(item.product_id);
								//可退数 = 已发货数 - 已退货数
								let wait_return = parseFloat((Math.max(0, (item.deliver_count || 0) - (item.return_count || 0))).toFixed(6));
								return {
									type: 1,
									order_id: item.order_id,
									order_product_id: item.id,
									main_product_count: item.main_product_count,
									product_id: item.product_id,
									product_code: item.product_code,
									product_name: item.product_name,
									product_count: item.product_count,
									product_spec: item.product_spec,
									product_price: item.product_price,
									unit: item.unit,
									deliver_count: item.deliver_count || 0,
									return_count: wait_return,
									orderOptions: [{
										name: data.detailInfo.order_code,
										value: item.id
									}]
								};
							});

							//按选中的产品重新加载产品详细信息
							this.request({
								url:'/product/listSubUnit',
								data: {
									business_type: 2,
									warehouse_id: this.warehouse_id,
									product_ids: ids
								},
								success: async data => {
									this.$refs.returnProductTable.$refs.list.setData(
										await this.$refs.returnProductTable.setDefaultData(product_list, {
											work_type_id: 54,
											source_list: product_list.map(item => {
												return [{
													ref_work_type_id: 1,
													ref_id: item.order_id
												}, {
													ref_work_type_id: 41,
													ref_id: item.order_product_id
												}, {
													ref_work_type_id: 7,
													ref_id: item.product_id
												}]
											})
										})
									);
								}
							});
						}
					});
				//编辑退货单
				}else if(returnId != null){
					this.return_id = returnId;
					this.getDetail();
					title = "编辑退货单";
				}
				this.$refs.dialog.open({
					title: title
				});
			},

			//查询退货单详情
			getDetail() {
				this.request({
					url: '/order/return/detail',
					data: {
						id: this.return_id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;

						this.$refs.orderForm.set(this.detailData);
						if (this.detailData && this.detailData.warehouse_id && this.detailData.warehouse_name){
							this.warehouseOptions = [{
								name: this.detailData.warehouse_name + ' | ' + this.detailData.warehouse_code,
								value:this.detailData.warehouse_id
							}];
							this.warehouse_id = this.detailData.warehouse_id;
						}else {
							this.warehouseOptions = [];
						}
						if (this.detailData && this.detailData.customer_id && this.detailData.customer_name){
							this.customer_id = this.detailData.customer_id;
							this.customerOptions = [{
								name:this.detailData.customer_code +' - ' +this.detailData.customer_name,
								value:this.detailData.customer_id
							}];
						}else {
							this.customerOptions = [];
						}

						var product_list = data.productList.map(item => {
							if(item.order_product_id){
								item.type = 1;
								item.orderOptions = [{
									name: item.order_number,
									value: item.order_product_id
								}];
							}else{
								item.type = 2;
								item.productCodeOptions = [{
									name: item.product_code + ' | ' + item.product_name,
									value: item.product_id
								}];
							}
							return item;
						});

						//加载退货产品列表
						this.$refs.returnProductTable.$refs.list.setData(product_list);
					}
				});
			},

			changeCustomer({data}) {
				if (!data) return;
				this.$refs.customForm.setDefaultData({
					work_type_id: 53,
					source_list: [[{
						ref_work_type_id: 11,
						ref_id: data.id
					}]]
				});
				//重新加载可退货产品
				this.loadCustomerOrder();
			},

			//按客户加载可退货明细列表
			loadCustomerOrder(){
				//清空退货产品
				this.$refs.returnProductTable.$refs.list.setData([]);
				//加载新的可退货产品列表
				this.request({
					url:'/order/return/can/list',
					data: {
						customer_id: this.customer_id,
						return_id: this.return_id
					},
					success:data => {

						let ids = [];
						//处理数据
						var product_list = data.map(item => {
							item.type = 1;
							item.order_product_id = item.id;
							item.return_count = item.wait_return_count;
							item.orderOptions = [{
								name: item.order_code,
								value: item.id
							}];
							ids.push(item.product_id);
							return item;
						});

						//按选中的产品重新加载产品详细信息
						this.request({
							url:'/product/listSubUnit',
							data: {
								business_type: 2,
								warehouse_id: this.warehouse_id,
								product_ids: ids
							},
							success: async data => {
								this.$refs.returnProductTable.$refs.list.setData(
									await this.$refs.returnProductTable.setDefaultData(product_list, {
										work_type_id: 54,
										source_list: product_list.map(item => {
											return [{
												ref_work_type_id: 1,
												ref_id: item.order_id
											}, {
												ref_work_type_id: 41,
												ref_id: item.order_product_id
											}, {
												ref_work_type_id: 7,
												ref_id: item.product_id
											}]
										})
									})
								);
							}
						});
					}
				})
			},

			/**清除无效数据**/
			clearNonData(){
				const dataList = this.$refs.returnProductTable.$refs.list.getRow();
				for (let i = dataList.length - 1; i >= 0; i--) {
				    const row = dataList[i];
				    const count = row.data?.return_count;
				    // 数量为空、undefined、null、0 都判定为无效
				    if (!count || Number(count) === 0) {
						row.remove();
				    }
				}
				this.$message({
					message: '已清除无效数据'
				})
			},

			/*******搜索可用于退货的【产品列表信息】下拉框信息*****************/
			searchOrderProduct(keyword, resolve){
				this.request({
					url:'/order/return/can/list',
					data: {
						customer_id: this.customer_id,
						return_id: this.return_id,
						keyword: keyword
					},
					success:data => {
						var option = data.map(item => {
							return {
                              name: item.order_code,
                              value: item.id,
                              data: item
							}
						});
						resolve(option);
					}
				})
			},

			/**************查询默认仓库*************/
			getDefaultWarehouse(){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE'
					},
					success:data => {
						if (data.length == 1){
							this.warehouseOptions = [data[0]];
							this.warehouse_id = data[0].value;
						}
					}
				});
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

            /*******搜索【客户】下拉框信息*****************/
            searchCustomer(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'CUSTOMER',
                        keyword:keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			/*******选择产品*****************/
			searchProduct(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CP_PRODUCT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/**************变更订单产品下拉框数据******************/
			changeOrderProduct(selectData, update) {
                if (selectData.data) {
					//按选中的产品重新加载产品详细信息
					this.request({
						url: '/product/listSubUnit',
						data: {
							business_type: 2,
							warehouse_id: this.warehouse_id,
							product_ids: [selectData.data.product_id]
						},
						success: async ([data]) => {
							//可退数 = 已发货数 - 已退货数
							let returnCount = parseFloat(Math.max(0, (selectData.data.deliver_count || 0) - (selectData.data.return_count || 0)).toFixed(6));
							update(await this.$refs.returnProductTable.setDefaultData(
								Object.assign({}, data, {
									id: null,
									type: 1,
									order_id: selectData.data.order_id,
									order_product_id: selectData.data.id,
									main_product_count: selectData.data.main_product_count,
									product_id: data.id,
									deliver_count: selectData.data.deliver_count || 0,
									return_count: returnCount,
									product_price: selectData.data.product_price
								}),
								{
									work_type_id: 54,
									source_list: [[{
										ref_work_type_id: 1,
										ref_id: selectData.data.order_id
									}, {
										ref_work_type_id: 41,
										ref_id: selectData.data.id
									}, {
										ref_work_type_id: 7,
										ref_id: selectData.data.product_id
									}]]
								}
							))
						}
					});
                } else {
					update({})
				}
			},

			/**************变更【产品】下拉框数据******************/
			changeProduct(selectData, update) {
				if (selectData.data) {
					//按选中的产品重新加载产品详细信息
					this.request({
						url:'/product/listSubUnit',
						data: {
							business_type: 2,
							warehouse_id: this.warehouse_id,
							product_ids: [selectData.data.id]
						},
						success: async ([data]) => {
							update(await this.$refs.returnProductTable.setDefaultData(
								Object.assign({}, data, {
									id: null,
									type: 2,
									order_id: 0,
									order_product_id: 0,
									product_id: data.id,
									return_count: 0
								}),
								{
									work_type_id: 54,
									source_list: [[{
										ref_work_type_id: 7,
										ref_id: selectData.data.id
									}]]
								}
							))
						}
					});
				} else {
					update({})
				}
			},

			/*******添加订单信息【根据订单进行退货】**************************/
			async addReturnOrder(){
				if (!this.warehouse_id){
					this.$message({
						message:'请先选择退货仓库',
						type: 'warn'
					});
					return;
				}
                var rowData = {
                    type:1,
                    return_count:0
                };
                this.$refs.returnProductTable.$refs.list.push(
					await this.$refs.returnProductTable.setDefaultData(rowData)
				);
			},

			/*******添加产品信息【不关联订单进行退货】**************************/
			async addReturnProduct(){
				if (!this.warehouse_id){
					this.$message({
						message:'请先选择退货仓库',
						type: 'warn'
					});
					return;
				}
                var rowData = {
                    type:2,
                    order_id:0,
                    order_product_id:0,
                    return_count:0
                };
                this.$refs.returnProductTable.$refs.list.push(
					await this.$refs.returnProductTable.setDefaultData(rowData)
				);
			},

			/******删除产品行数据********/
			removeProductRow(data, remove) {
				remove();
			},


			/*******提交编辑数据********************/
			submitHandle(stop, next) {
                stop();
                var product_list = this.$refs.returnProductTable.$refs.list.getData();
                this.$refs.orderForm.submit({
					url: this.return_id==0?'/order/return/add':'/order/return/edit',
                    rule: {
                        warehouse_id:'请选择退货仓库',
                        product_list: data => {
                            var flag = true;
                            if(product_list.length == 0){
                                flag = false;
                                return '请至至少添加一件退货产品';
                            }

                            product_list.forEach(item => {
                                if(!item.product_id){
                                  flag = false;
                                }
								if(!item.return_count || parseFloat(item.return_count) <= 0){
								  flag = false;
								}
                            });

							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}

                            //判断数据是否重复
                            for (var i=0; i<product_list.length; i++) {
								let item = product_list[i];
                                for (var j=i+1; j<product_list.length; j++) {
									if (item.order_id == product_list[j].order_id
											&& item.order_product_id == product_list[j].order_product_id
											&& item.product_id == product_list[j].product_id) {
										flag = false;
										return '第‘'+(i+1)+'’行和第‘'+(j+1)+'’行订单/产品数据重复';
									}
                                }
                            }

                            return this.$refs.returnProductTable.validate();
                        },
                        ...this.$refs.customForm.rule
                    },
                    dataFormatter: data => {
						data.id = this.return_id||0;
                        data.customer_id = data.customer_id||0;//退货客户
                        //产品列表
                        data.product_list = product_list.map(item => {
                            return {
                                order_id: item.order_id,
                                order_product_id: item.order_product_id,
                                product_id: item.product_id,

                                return_count: item.return_count,
								product_price: item.product_price,
                                custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
                            }
                        });
                        //表单自定义字段
                        data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
                        return data;
                    },
                    success: () => {
                        next();
                        this.$message({
                            type: 'success',
                            message:'退货成功',
                        });
                        //刷新页面
                        this.$emit('resolve');
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>
